import { render, staticRenderFns } from "./ArtifactsTab.vue?vue&type=template&id=6558f014&"
import script from "./ArtifactsTab.vue?vue&type=script&lang=js&"
export * from "./ArtifactsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports